import { USER_DASHBOARD_PAGE_KEY } from '../page-key';
import { routesLocalesEn } from '../routes/i18n';
import { savedCoursesEn } from '../routes/SavedCourses/i18n';
import { EXTERNAL_LOCALES_EN } from './externals';

const en = {
  [USER_DASHBOARD_PAGE_KEY]: {
    ...routesLocalesEn,
    ...savedCoursesEn,
    // Titles
    UD_ENROLLMENTS_TITLE: 'My courses',
    UD_ENROLLMENTS_COURSES: 'All my courses',
    UD_ENROLLMENTS_TRACKS: 'My specializations',
    UD_ENROLLMENTS_CAREERS: 'My careers',
    UD_ENROLLMENTS_BUNDLES: 'My certificates',
    UD_ENROLLMENTS_DEGREES: 'MicroDegree',
    UD_ENROLLMENTS_ACADEMIES: 'Academies',
    UD_ENROLLMENTS_NEW_TAG: 'New',
    UD_ENROLLMENTS_BOOTCAMPS: 'Bootcamp',
    UD_CLASSNOTES_TITLE: 'My notes',
    UD_PROJECTS_TITLE: 'My projects',
    UD_DIPLOMAS_TITLE: 'My diplomas',
    UD_STUDY_PLAN_TITLE: 'My study plan',
    // Onboarding
    UD_ONBOARDING_WELCOME_TITLE: 'Welcome to your new student dashboard!',
    UD_ONBOARDING_WELCOME_DESC:
      'We talk about the new improvements we have for you.',
    UD_ONBOARDING_MOBILE_MENU_TITLE: 'New menu bar',
    UD_ONBOARDING_MOBILE_MENU_DESC:
      'We have implemented a new menu bar for you to navigate between the sections of My Courses, My Notes, My Projects, My Diplomas, and My Study Plan.',
    UD_ONBOARDING_ENROLLMENTS_TITLE: 'My courses',
    UD_ONBOARDING_ENROLLMENTS_DESC:
      'Here you will find not only all your registered courses but also the progress of your specializations.',
    UD_ONBOARDING_CLASSNOTES_TITLE: 'My notes',
    UD_ONBOARDING_CLASSNOTES_DESC:
      'All the notes made in all your courses can be reviewed here.',
    UD_ONBOARDING_PROJECTS_TITLE: 'My projects',
    UD_ONBOARDING_PROJECTS_DESC:
      'Find all the projects you are working on in this section. You can also view the review status of each one, even those that are already certified.',
    UD_ONBOARDING_DIPLOMAS_TITLE: 'My diplomas',
    UD_ONBOARDING_DIPLOMAS_DESC:
      'Find your Crehana diplomas here, after your final project is approved.',
    UD_ONBOARDING_STUDY_PLAN_TITLE: 'My study plan',
    UD_ONBOARDING_STUDY_PLAN_DESC:
      'Did you know that successful people generate habits? In this section, we help you achieve your goals.',
    UD_ONBOARDING_NIGHT_SWITCH_TITLE: 'Join the dark side',
    UD_ONBOARDING_NIGHT_SWITCH_DESC:
      'Personalize your dashboard to the dark mode by activating this option.',
    UD_ONBOARDING_CONFIG_TITLE: 'Your account settings',
    UD_ONBOARDING_CONFIG_DESC:
      'Have more direct access to all your account settings in this link.',
    UD_ONBOARDING_FAQ_TITLE: 'Solving your questions',
    UD_ONBOARDING_FAQ_DESC:
      'If you still have questions about how the platform works, we are happy to help you in the Crehana Help Center.',
    UD_ONBOARDING_SEARCH_TITLE: 'What are you looking for in your dashboard?',
    UD_ONBOARDING_SEARCH_DESC:
      'Make a more accurate search of what you need in your dashboard in this section.',
    // Filters & FAQ
    UD_CONFIGURATION: 'Configuration',
    UD_SEARCH_HINT: 'Search courses, projects...',
    UD_SEARCH_PROJECT_SUBTITLE: '{{course}} Project',
    UD_SEARCH_ERROR:
      'An error occurred while retrieving dashboard information.',
    UD_SEARCH_NO_RESULTS: "We couldn't find any results for your search",
    UD_GO_TO_COURSES: 'View my courses',
    UD_FILTER_LABEL: 'Filter by',
    UD_FAQ_COURSE: "Can't find my course",
    UD_FAQ_PROJECT_UPLOAD: 'Project uploads',
    UD_FAQ_START_COURSES: 'How do I start my assigned courses?',
    UD_FAQ_DIPLOMA: 'How to get my diploma?',
    UD_FAQ_ONBOARDING: 'How does my dashboard work?',
    UD_FAQ_GENERAL: 'Still have questions? Visit the',
    UD_FAQ_GENERAL_LINK: 'Crehana Help Center',
    // Enrollments components and actions
    UD_TRACK_TITLE: '{{title}} Specialization',
    UD_DURATION: 'Duration: {{duration}}',
    UD_DOWNLOAD_SYLLABUS: 'Download syllabus',
    UD_DOWNLOAD_DIPLOMA: 'Download diploma',
    UD_START_COURSE: 'Start course',
    UD_CONTINUE_COURSE: 'Continue course',
    UD_REWATCH_COURSE: 'Watch again',
    UD_CREATE_PROJECT: 'Start project',
    UD_EDIT_PROJECT: 'Edit project',
    UD_GO_TO_PROJECT: 'View project',
    UD_MODULE_LIST_PROGRESS: '{{completed}}/{{total}} modules completed',
    UD_COURSE_LIST_PROGRESS: '{{completed}}/{{total}} courses completed',
    UD_PROJECT_LIST_PROGRESS: '{{completed}}/{{total}} certified projects',
    UD_SAVED_COURSES_TITLE: 'Saved courses',
    UD_SAVED_COURSES_TOUR_TITLE: 'Save for later',
    UD_SAVED_COURSES_TITLE_DESC:
      "Now you can save courses. Don't lose sight of your learning!",
    // FAQ'S
    UD_UPLOAD_PROJECTS: 'How do I upload my projects?',
    UD_START_COURSES: 'How do I start my assigned courses?',
    UD_CHAT_WITH_MENTORS: 'How can I chat with mentors?',
    UD_UPLOAD_PROJECT: 'How do I upload my project?',
    UD_CANT_FIND_COURSES: "Can't find my courses",
    UD_UPLOAD_PROJECTS_TO_PLATFORM:
      'How do I upload my project to the platform?',
    UD_PROJECT_DESCRIPTION: 'Where can I find the description of my project?',
    ...EXTERNAL_LOCALES_EN,
  },
};
export default en;
